// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../../../internal/PageContentBlock';
import ArticleMeta from '../../../../internal/ArticleMeta';
import type { ArticleMetaType } from '../../../../internal/ArticleMeta';
import { Columns, BaseColumn } from '../../../../internal/Columns';

export type ArticleType = {|
  image: string,
  alt?: string,
  href: string,
  title: string,
  ...ArticleMetaType,
|};

const FeaturedArticles = (props: { articles: Array<ArticleType> }) => {
  if (props.articles.length === 0) {
    return null;
  }

  return (
    <PageContentBlock title="You may also be interested in">
      <Columns columns={4} centerColumns>
        {props.articles.map((article, index) => (
          /* eslint-disable react/no-array-index-key */
          <BaseColumn
            image={article.image}
            alt={article.alt}
            imageSize="Small"
            className={styles.article}
            key={index}
          >
            <ArticleMeta
              author={article.author}
              categories={article.categories}
              date={article.date}
            />
            <h3>
              <a href={article.href} className={styles.title}>
                {article.title}
              </a>
            </h3>
          </BaseColumn>
          /* eslint-enable react/no-array-index-key */
        ))}
      </Columns>
    </PageContentBlock>
  );
};

export default FeaturedArticles;
